import { useState } from "react";
import TextAreaInput from "../components/commons/TextAreaInput"
import TextInput from "../components/commons/TextInput"
import emailjs from 'emailjs-com';
import DialogConfirmation from "../components/dialogs/DialogConfirmation";
import { Helmet } from "react-helmet-async";
import { toast } from "react-toastify";
import { useAuth } from "../context/authContext";
import { addSuppportEmail } from "../firebase/messages";

const Contact = () => {

  const {user} = useAuth()
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [formData, setFormData] = useState({
    from_name: '',
    reply_to: '',
    message: '',
  })

  const handleChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const sendEmail = (e) => {
    e.preventDefault(); // Prevent the default form submission

    if (formData.from_name === '' || formData.reply_to === '' || formData.message === '') {
      toast.error('Please input all fields!')
      return
    } else {
      addSuppportEmail({
        senderId: user.uid,
        senderName: user.displayName,
        senderEmail: user.email,
        ...formData,
        createdAt: new Date(),
        replied: false,
      }).then(() => {
        console.log('Message saved to database');
      }).catch((error) => {
        console.error('Failed to save message to database:', error);
      });

      emailjs.send('service_gnf7v3w', 'template_yehu66t', formData, 'NIRiqDcijZRSB8OFh')
        // emailjs.send('service_o4ur9ym', 'template_yrqks58', formData, 'agZK2ITnVPTrHeoIi')
        .then((response) => {
          setShowConfirmModal(true)
          console.log('Email sent successfully!', response.status, response.text);
          // Optionally reset form data
          setFormData({ from_name: '', reply_to: '', message: '' });
        }, (err) => {
          console.error('Failed to send email. Error:', err);
        });
    }
  }

  return (
    <div>
      <Helmet>
        <title>Card Shop Exchange Support | Get Help & Answers</title>
        <meta name="description" content="Join Card Shop Exchange, the ultimate marketplace for trading Pokémon, Yu-Gi-Oh, One Piece, and more. Secure payments, verified sellers, and hassle-free transactions." />
      </Helmet>
      <DialogConfirmation
        message="Your message was sent successfully."
        open={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        buttonText="Done"
        title="Message Sent"
        iconSrc="/assets/icons/icon-check-circle.svg"
        type="confirm"
      />

      <h1 className="page-title">Support</h1>

      <span className="block uppercase mt-[120px] text-primary text-[12px] max-lg:mb-8">Get in touch</span>

      <div className="grid lg:grid-cols-2 mt-6">
        <div>
          <h1 className="text-white text-[90px] uppercase font-aero leading-[1em]">Need Help?</h1>

          <p className="text-base text-[#ffffff80] mt-7">If you have any queries or need any assistance, please<br /> get in touch with us, We will get back as soon as<br /> possible.</p>

          <div className="mt-20">
            <div className="flex items-center mb-8">
              <div className="flex justify-center items-center w-14 h-14 mr-4 rounded-[12px] border-gray border-[1px] bg-[#2C2C2C]">
                <img src="/assets/icons/icon-location.svg" alt="location" />
              </div>

              <a href="https://www.google.com/maps" target="_blank"><span className="text-white">23, Lorem ipsum, sit dolar <br />Nashville</span></a>
            </div>

            <div className="flex items-center mb-8">
              <div className="flex justify-center items-center w-14 h-14 mr-4 rounded-[12px] border-gray border-[1px] bg-[#2C2C2C]">
                <img src="/assets/icons/icon-envelop.svg" alt="envelop" />
              </div>

              <a href="mailto:contact@cardshopexchange.com"><span className="text-white">contact@cardshopexchange.com</span></a>
            </div>

            <div className="flex items-center mb-8">
              <div className="flex justify-center items-center w-14 h-14 mr-4 rounded-[12px] border-gray border-[1px] bg-[#2C2C2C]">
                <img src="/assets/icons/icon-call.svg" alt="call" />
              </div>

              <a href="tel:+4400000000"><span className="text-white">+44 00 000 000</span></a>
            </div>
          </div>
        </div>

        <form className="mt-3" onSubmit={sendEmail}>
          <TextInput
            placeholder="Name"
            inputClassName="placeholder:text-white/60 text-base"
            divClassName="group mt-7 !rounded-[12px] focus-within:border-[#1AB6F9] transition"
            value={formData.from_name}
            name="from_name"
            onChange={(v) => handleChange('from_name', v)}
          />
          <TextInput
            placeholder="Email"
            inputClassName="placeholder:text-white/60 text-base"
            divClassName="group mt-7 !rounded-[12px] focus-within:border-[#1AB6F9] transition"
            value={formData.reply_to}
            name="reply_to"
            onChange={(v) => handleChange('reply_to', v)}
          />
          <TextAreaInput
            textAreaClassName="placeholder:text-white/60 h-[190px]"
            placeholder="Message"
            divClassName="group mt-7 rounded-[12px] focus-within:border-[#1AB6F9] transition"
            name="message"
            value={formData.message}
            onChange={(v) => handleChange('message', v)}
          />

          <button type="submit" className="solo-button mt-8 bg-primary text-white w-full uppercase py-4 text-sm">
            Send Message
          </button>
        </form>
      </div>
    </div>
  )
}

export default Contact